import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=c329b7ea&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c329b7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c329b7ea')) {
      api.createRecord('c329b7ea', component.options)
    } else {
      api.reload('c329b7ea', component.options)
    }
    module.hot.accept("./UserSelect.vue?vue&type=template&id=c329b7ea&scoped=true", function () {
      api.rerender('c329b7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/UserSelect.vue"
export default component.exports